import { useGetReactivationEligiblePlans } from '@/modules/employer/components/EmployerReactivation/EmployerReactivationCardAndPlans/queries/useGetReactivationEligiblePlans.query';
import { useEmployerReactivationModalStore } from '@/modules/employer/components/EmployerReactivation/stores';
import { useEmployerReactivationStore } from '@/modules/employer/components/EmployerReactivation/stores/useEmployerReactivation.store';

export const useEmployerReactivationCardAndPlans = () => {
  const hasBankAccounts = useEmployerReactivationStore((state) => state.hasBankAccounts);
  const reCardEmployees = useEmployerReactivationStore((state) => state.reCardEmployees);
  const reactivatePlans = useEmployerReactivationStore((state) => state.reactivatePlans);
  const setReCardEmployees = useEmployerReactivationStore((state) => state.setReCardEmployees);
  const setReactivatePlans = useEmployerReactivationStore((state) => state.setReactivatePlans);
  const employerId = useEmployerReactivationModalStore((state) => state.employerId);
  const { plans, isLoading } = useGetReactivationEligiblePlans(employerId);

  const handleReCardChange = () => {
    setReCardEmployees(!reCardEmployees);
  };

  const handleReactivatePlansChange = () => {
    setReactivatePlans(!reactivatePlans);
  };

  return {
    reCardEmployees,
    reactivatePlans,
    hasBankAccounts,
    plans,
    isLoading,
    handleReCardChange,
    handleReactivatePlansChange,
  };
};
